import { useMobile } from "@/hooks";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Modal } from "@monsterindia/global-ui-components";
import React, { useContext, useState } from "react";

import { linkedinConsentUpdate } from "@/components/settings/api/networkUtils";
import { useProfileData } from "@/components/settings/contents/profileSettings";

import DisableReasonForm from "./DisableReasonForm";
import SuccessMessage from "./SuccessMessage";

const ProfileDisableReason: React.FC<ProfileDisableReasonProps> = ({
  setProfileAutoUpdateToggle,
  profileAutoUpdateToggle,
  showReasonModal,
  setShowReasonModal,
  setProfileDisableReason,
  profileDisableReason,
  setToast,
}) => {
  const { toastErrorMsg } = useProfileData?.profileAutoUpdate ?? {};
  const [showSuccess, setShowSuccess] = useState(false);
  const isMobile = useMobile();
  const handleCloseModal = () => {
    setShowReasonModal(false);
    setProfileDisableReason(null);
  };

  const handleTurnOffBtn = async () => {
    const newValue = !profileAutoUpdateToggle;
    try {
      const response = await linkedinConsentUpdate(
        newValue,
        profileDisableReason,
      );
      if (response) {
        trackClevertapEvents.eventPush("Profile_update_consent", {
          profile_consent_added: "true",
          reason:
            profileDisableReason === "INACCURATE_PROFILE_INFORMATION"
              ? "Inaccurate Profile Information"
              : "Other Reasons",
        });
        setProfileAutoUpdateToggle(newValue);
        setShowSuccess(true);
      }
    } catch (error) {
      setToast({
        text: toastErrorMsg ?? "Something went wrong!",
        type: "error",
        show: true,
      });
    }
  };

  const eventFunctionHandler = (event: { value?: string }) => {
    setProfileDisableReason(event?.value ?? null);
  };

  return (
    <div className="p-4">
      <Modal
        screenAlignment={isMobile ? "bottom-sheet" : "center"}
        showModal={showReasonModal}
        closeModal={handleCloseModal}
        showCloseButton={true}
        showHandleBar={isMobile}
        customClass="!px-0 !py-2 !h-max"
      >
        {showSuccess ? (
          <SuccessMessage />
        ) : (
          <DisableReasonForm
            isMobile={isMobile}
            handleModal={handleCloseModal}
            handleTurnOffBtn={handleTurnOffBtn}
            profileDisableReason={profileDisableReason}
            eventFunctionHandler={eventFunctionHandler}
          />
        )}
      </Modal>
    </div>
  );
};

export default ProfileDisableReason;
